import { ReviewStatus } from "@redotech/redo-model/review/review";
import { ReviewFieldDbParser } from "@redotech/redo-model/review/review-db-parser";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const upsertReview = {
  name: "upsertReview" as const,
  input: z.object({
    status: z.enum(ReviewStatus),
    shopifyProductId: z.string().min(1),
    customer: z.optional(
      z.object({
        email: z
          .string()
          .email()
          .transform((val) => val.toLowerCase().trim()),
      }),
    ),
    reviewFields: z.array(ReviewFieldDbParser),
    existingReviewId: zExt.objectId().optional(),
    orderId: zExt.objectId().optional(),
  }),
  output: z.object({ reviewId: z.string() }),
};
